import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TransactionResult } from '../../core/services/interfaces/transaction-result';
import { LoginService } from '../login-service';
import * as jQuery from 'jquery';
import { TranslateService } from '../../core/services/translate-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  formGroup: FormGroup;
  applicationName: string = window["configuration"].applicationName;
  applicationVersion: string = window["configuration"].applicationVersion;

  constructor(
    private loginService: LoginService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    this.formGroup = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    console.log(this.translateService.data);
  }

  login(): void {
    var self = this;

    if (this.formGroup.valid) {
      var $this = jQuery('.login'),
        $state = $this.find('button > .state');
      $this.addClass('loading');
      $state.html(this.translateService.data.GENERAL.AUTHENTICATING);

      this.loginService.login(this.formGroup.value).subscribe({
        next: (result: TransactionResult<string>) => {
          if (result.success) {
            $this.addClass('ok');
            $state.html(this.translateService.data.GENERAL.WELCOME);
            setTimeout(function () {
              self.loginService.generateAuthentication(result.data);
            }, 1000);
          }
          else {
            $state.html(this.translateService.data.LOGIN.LOG_IN);
            $this.removeClass('ok loading');
          }
        },
        error: (error: any) => {
          $state.html(this.translateService.data.LOGIN.LOG_IN);
          $this.removeClass('ok loading');
          this.toastrService.error(this.translateService.data.LOGIN.ERROR);
        }
      });
    }
  }
}
